import React from 'react';
import { Input, Form, Button } from 'antd';

const { TextArea } = Input;

const Editor = (props: any) => {
  const { onChange, value, onSubmit } = props;
  return (
    <>
      <Form.Item>
        <TextArea rows={4} onChange={onChange} value={value} />
      </Form.Item>

      <Form.Item>
        <Button htmlType="submit" onClick={onSubmit} type="primary">
          Add Comment
        </Button>
      </Form.Item>
    </>
  );
};

export default Editor;
